(function(){
function moneyFormat(cents){
  try {
    return Shopify.formatMoney(cents, Shopify.money_format);
  } catch {
    return '$' + (cents/100).toFixed(2);
  }
}

  function getProductForm(root){
    const id = root.dataset.formId && document.getElementById(root.dataset.formId);
    if (id) return id;
    const section = root.closest('[id^="shopify-section-"]') || document;
    const forms = Array.from(section.querySelectorAll('form[action^="/cart/add"]'));
    return forms.find(f => f.querySelector('input[name="id"], select[name="id"]')) || forms[0] || null;
  }

  function forceFormVariantId(form, variantId, variantObj){
    if (!form) return;

    const fields = form.querySelectorAll('input[name="id"], select[name="id"]');
    fields.forEach(el => {
      if (el.tagName === 'SELECT') {
        let opt = Array.from(el.options).find(o => Number(o.value) === Number(variantId));
        if (!opt) { opt = new Option(variantId, variantId, true, true); el.add(opt); }
        el.value = String(variantId);
      } else {
        el.value = String(variantId);
      }
      el.removeAttribute('disabled');
      el.dispatchEvent(new Event('input', {bubbles:true}));
      el.dispatchEvent(new Event('change', {bubbles:true}));
    });

    const buttons = form.querySelectorAll('button, [type="submit"], .product-form__submit');
    buttons.forEach(btn => {
      btn.dataset.variantId = String(variantId);
      btn.dataset.variant = String(variantId);
      btn.dataset.productVariantId = String(variantId);
    });

    form.dispatchEvent(new Event('change', {bubbles:true}));
    form.dispatchEvent(new CustomEvent('variant:change', {bubbles:true, detail:{variant: variantObj}}));
    form.dispatchEvent(new CustomEvent('variantChange',  {bubbles:true, detail:{variant: variantObj}}));

    if (history.replaceState) {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url.toString());
    }
  }

  function updatePriceUI(root, variant){
    const priceEl = root.querySelector('[data-vht-price]');
    const compEl  = root.querySelector('[data-vht-compare]');
    if (!priceEl || !variant) return;
    priceEl.textContent = moneyFormat(variant.price);
    const ca = variant.compare_at_price;
    if (ca && ca > variant.price) {
      compEl.textContent = moneyFormat(ca);
      compEl.classList.remove('is-hidden');
    } else {
      compEl.textContent = '';
      compEl.classList.add('is-hidden');
    }
  }

  function setDiffVisibility(root, show){
    const chip = root.querySelector('[data-vht-diff]');
    if (!chip) return;
    const diffCents = Number(chip.dataset.diffCents || 0);
    if (show && diffCents !== 0){
      const sign = diffCents > 0 ? '+' : '−';
      chip.textContent = sign + moneyFormat(Math.abs(diffCents));
      chip.classList.remove('is-hidden');
    } else {
      chip.classList.add('is-hidden');
      chip.textContent = '';
    }
  }

  function setToggleDisabled(btn, disabled){
    if (!btn) return;
    btn.disabled = !!disabled;
    btn.classList.toggle('vht-disabled', !!disabled);
  }

  function mount(root){
    if (!root || root.dataset.vhtMounted === 'true') return;

    const toggleBtn = root.querySelector('[data-vht-toggle]');
    const labelEl   = root.querySelector('[data-vht-variant-label]');
    if (!toggleBtn || !labelEl) { root.dataset.vhtMounted = 'true'; return; }

    const onId      = Number(root.dataset.onVariantId);
    const offId     = Number(root.dataset.offVariantId);
    const onTitle   = root.dataset.onTitle;
    const offTitle  = root.dataset.offTitle;
    const productId = root.dataset.productId;

    let productJson = null;
    const jsonEl =
      document.querySelector(`script[type="application/json"][data-product-id="${productId}"]`) ||
      document.getElementById(`ProductJson-${productId}`);
    if (jsonEl) { try { productJson = JSON.parse(jsonEl.textContent.trim()); } catch(e){} }
    const getVariant = id => productJson?.variants?.find(v => Number(v.id) === Number(id));

    let onAvailable = null;

    if (root.dataset.onAvailable !== undefined) {
      onAvailable = root.dataset.onAvailable === 'true';
    } else {
      const vOn = getVariant(onId);
      if (vOn && typeof vOn.available !== 'undefined') onAvailable = !!vOn.available;
    }

    setToggleDisabled(toggleBtn, onAvailable === false);

    root.dataset.currentVariantId = String(offId);

    toggleBtn.setAttribute('aria-checked', 'false');
    labelEl.textContent = offTitle;
    setDiffVisibility(root, false);

    const form = getProductForm(root);
    forceFormVariantId(form, offId, getVariant(offId));
    updatePriceUI(root, getVariant(offId));

    if (form) {
      const sync = (ev) => {
        if (ev && (ev.target.closest('[data-vht-toggle]') || ev.target.closest('[data-component="vht"]'))) return;
        const currentId = Number(root.dataset.currentVariantId);
        forceFormVariantId(form, currentId, getVariant(currentId));
      };

      form.addEventListener('submit', sync, true);

      const submitters = form.querySelectorAll('button[type="submit"], [name="add"], .product-form__submit');
      submitters.forEach(btn => {
        btn.addEventListener('pointerdown', sync, { capture: true });
        btn.addEventListener('click',       sync, { capture: true });
      });
    }

    toggleBtn.addEventListener('click', () => {
      let canGoOn = true;
      if (root.dataset.onAvailable !== undefined) {
        canGoOn = root.dataset.onAvailable === 'true';
      } else {
        const vOn = getVariant(onId);
        if (vOn && typeof vOn.available !== 'undefined') canGoOn = !!vOn.available;
      }

      const goingOn = toggleBtn.getAttribute('aria-checked') !== 'true';
      if (goingOn && !canGoOn) return;

      toggleBtn.setAttribute('aria-checked', String(goingOn));

      const id    = goingOn ? onId : offId;
      const title = goingOn ? onTitle : offTitle;

      root.dataset.currentVariantId = String(id);
      labelEl.textContent = title;
      setDiffVisibility(root, goingOn);

      const f = getProductForm(root);
      forceFormVariantId(f, id, getVariant(id));
      updatePriceUI(root, getVariant(id));
    });

    root.dataset.vhtMounted = 'true';
  }

  function mountAll(){
    document.querySelectorAll('[data-component="vht"]').forEach(mount);
  }

  document.addEventListener('DOMContentLoaded', mountAll);
  window.addEventListener('pageshow', mountAll);
  document.addEventListener('shopify:section:load', mountAll);
  document.addEventListener('shopify:section:select', mountAll);
  document.addEventListener('shopify:section:reorder', mountAll);

  document.addEventListener('turbo:load', mountAll);
  document.addEventListener('page:load', mountAll);
  document.addEventListener('swup:contentReplaced', mountAll);
  document.addEventListener('barba:after', mountAll);

  const mo = new MutationObserver(() => mountAll());
  mo.observe(document.documentElement, {childList:true, subtree:true});
})();